import React, { Component } from "react";
import { SponsorComponent } from "../../components/Sponsor";
import { Link } from "react-router-dom";

// TODO: Change descriptions, links 
const data = {
  year: "2025",
  anchor: [
    {
      name: "CSI",
      logo: "CSI Logo.PNG",
      description:
        "CSI is a leading provider of structural engineering software and services. They provide a comprehensive suite of tools for structural engineering, including analysis, design, and documentation.",
      link: "https://www.csiamerica.com",
    },
  ],
  gold: [
    {
      name: "WSP",
      logo: "wsp_2023.png",
      description:
        "WSP is one of the world's leading engineering consulting firms. They provide technical and strategic advisory services in diverse engineering and infrastructure sectors.",
      link: "https://www.wsp.com/en-ca",
    },
    {
      name: "RJC",
      logo: "rjc_logo.jpg",
      description:
        "Read Jones Christoffersen Ltd. (RJC) is one of the largest engineering firms in Canada specializing in structural engineering, structural restoration, building science and parking planning services. We are a large but specialized firm, with a national staff of over 450 people in offices across Canada. We've worked on many UofT projects, including the Faculty of Law expansion, the UTSC Environmental Science and Chemistry Building and the UTM North Building Reconstruction.",
      link: "https://www.rjc.ca/",
    },
  ],
  silver: [
    {
      name: "PICCO",
      logo: "PICCO Logo.png",
      description:
        "SHAPING PROGRESS. DESIGNING LEGACY. PICCO Engineering is an award-winning professional services firm founded in 1992, with 3 distinct areas of expertise: STONE consulting, cladding and engineered anchor systems.RESIDENTIAL engineering for low/mid/high-rise structures.STRUCTURAL engineering that applies to a variety of building types and materials.We are proud to have developed numerous long-term relationships with our valued clients over the years, and understand the importance of collaboration, trust and respect in all our interactions. We believe there is an innovative solution to every engineering challenge as we strive to facilitate the vision of our clients.",
      link: "https://www.piccostructures.com",
    },
  ]
};

export default class Sponsors2025 extends Component {
  render() {
    return (
      <div>
        <SponsorComponent data={data} />
      </div>
    );
  }
}
